import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { LogoMobileLayout, MobileLoaderLayout } from 'modules/Layout';
import { useCountrySettings } from './hooks';
import PatientProfile from './PatientProfile';
import PatientProfileMigration from './PatientProfileMigration';
import usePatientSetupEffects from './usePatientSetupEffects';
const PatientSetup = ({ enrollCode, invitationCode, externalReturnUrl })=>{
    const countrySettings = useCountrySettings();
    const { hasCentralStorage, isPayerMandatory } = usePatientSetupEffects(externalReturnUrl);
    if (!countrySettings) {
        return /*#__PURE__*/ _jsx(MobileLoaderLayout, {});
    }
    if (hasCentralStorage && !isPayerMandatory) {
        return /*#__PURE__*/ _jsx(PatientProfileMigration, {
            enrollCode: enrollCode,
            invitationCode: invitationCode
        });
    }
    return /*#__PURE__*/ _jsx(LogoMobileLayout, {
        children: /*#__PURE__*/ _jsx(PatientProfile, {
            enrollCode: enrollCode,
            invitationCode: invitationCode,
            hasCentralStorage: hasCentralStorage
        })
    });
};
export default PatientSetup;
